import React from "react";

import styled from "styled-components/macro";

import { Body, Link, Title, TitleIcon, TitleWrapper, Wrapper } from "./Styles";

export default function NewFeatures({ show }) {
  if (!show) return null;

  return (
    <StyledWrapper>
      <TitleWrapper>
        <TitleIcon>
          <i className="fad fa-gift" />
        </TitleIcon>
        <TitleCustom>New features just for you!</TitleCustom>
      </TitleWrapper>

      <Body>
        We love hearing your feedback and building features that make your work
        in ministry easier. Our ever-helpful Happiness Engineers and top-notch
        developers are always cooking up something behind the scenes and making
        exciting updates.
      </Body>
      <LinkCustom
        href="https://flocknote.com/feature-updates/"
        target="_blank"
        rel="noreferrer"
      >
        See our growing list of new features &gt;
      </LinkCustom>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  background-color: none;
  box-shadow: none;
`;

const TitleCustom = styled(Title)`
  line-height: 1;
`;

const LinkCustom = styled(Link)`
  font-size: 14px;
`;
